import React, { useEffect } from 'react'
import { observer } from 'mobx-react-lite'
import { Routes, Route, useNavigate } from 'react-router-dom'
import { useStores } from '../../../cls/stores/MobXProvider'
import { PageLoader } from '../../../components/Shared'
import MonthlyReportsLst from './MonthlyReportsLst'
import MonthlyReportEdit from './MonthlyReportEdit'
import {
	actLoadMonthlyReport,
	requireMonthlyReportsById
} from '../../../stores/monthly-reports/actions'
import { useSmartTranslation } from '../../../cls/TranslationContext'
/**
 * @function MonthlyReportsMain
 * @description Root component for the monthly reports module. Manages routing between list and edit views and checks user permissions.
 */
const MonthlyReportsMain = () => {
	const navigate = useNavigate()
	const { users } = useStores()
	const { loggedInUserId, loggedInUser } = users
	const isAdmin = loggedInUser?.isAdmin
	const isSuperAdmin = loggedInUser?.isSuperAdmin
	const { t } = useSmartTranslation()

	useEffect(() => {
		if (!users.isLoggedIn) {
			navigate('/logout')
			return
		}
	}, [loggedInUserId])

	// If the user does not have personal permission
	// and lacks the required permissions for the action and resource
	// Display a message indicating lack of permissions
	if (
		!(isAdmin || isSuperAdmin || users.canUser('read', 'monthly_reports'))
	) {
		return (
			<div style={{ textAlign: 'center' }}>
				{t('__denied.access').charAt(0).toUpperCase() +
					t('__denied.access%__feature-off%_monthly-report')
						.toLowerCase()
						.slice(1)}
			</div>
		)
	}

	return (
		<Routes>
			<Route
				path=":itmId/*"
				element={
					<PageLoader
						forceLoad={true}
						requireItm={(id) => {
							return requireMonthlyReportsById(id)
						}}
						loadItm={(id) => actLoadMonthlyReport(id)}
						targetLst="monthly-reports"
					/>
				}
			>
				<Route path="edit" element={<MonthlyReportEdit />} />
				<Route
					path="view"
					element={<MonthlyReportEdit viewOnly={true} />}
				/>
			</Route>
			<Route index element={<MonthlyReportsLst />} />
			<Route path="*" element={<div>Not found</div>} />
		</Routes>
	)
}
export default observer(MonthlyReportsMain)
